import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { ServiceMaster } from "./ServiceMaster";

const ServiceManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/:service_flag`} component={ServiceMaster} />
  </Switch>
);

export const ServiceManagement = withRouter(ServiceManagementRoutes);